import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import {
  QaiComparisonBlockComponent,
  QaiInnerWrapComponent,
  QaiLoadingComponent,
} from '@qai/ui';
import {
  AccuracyFeedbackState,
  IAccuracyClaim,
} from 'src/app/interfaces/iaccuracy-feedback';
import { MessageBlockComponent } from 'src/app/components/shared/message-block/message-block.component';

/**
 * Renders one of four accuracy states. Presentational only — the parent owns
 * the fetch and the flag gate and drives this through its inputs.
 */
@Component({
  selector: 'app-results-accuracy',
  standalone: true,
  templateUrl: './results-accuracy.component.html',
  styleUrls: ['./results-accuracy.component.scss'],
  imports: [
    CommonModule,
    TranslocoModule,
    QaiComparisonBlockComponent,
    QaiInnerWrapComponent,
    QaiLoadingComponent,
    MessageBlockComponent,
  ],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'results' }],
})
export class ResultsAccuracyComponent {
  @Input() state: AccuracyFeedbackState = AccuracyFeedbackState.Loading;
  @Input() claims: IAccuracyClaim[] = [];

  /** Exposed for the template's state comparisons. */
  readonly AccuracyFeedbackState = AccuracyFeedbackState;

  readonly flaggedIcon = 'message-question-square' as const;
  readonly clearIcon = 'message-check-square' as const;
  readonly errorIcon = 'message-question-square' as const;
}
